import {
  createOrderForGroupBookingUsingEmailLinkMutation,
  createOrderForGroupBookingUsingEmailLinkDttMutation,
  CreateOrderForGroupBookingUsingEmailLinkResponse,
  CreateOrderForGroupBookingUsingEmailLinkDttResponse,
  ErrorResponseDtt,
} from '@marriott/mi-groups-graphql';
import { useMutationTransformer } from '../../hooks';

type createOrderForGroupBooking = {
  createOrderForGroupBookingUsingEmailLink: CreateOrderForGroupBookingUsingEmailLinkResponse;
};

type createOrderForGroupBookingDtt = {
  sales: {
    groupSales: {
      createGroupBookingOrder: CreateOrderForGroupBookingUsingEmailLinkDttResponse | ErrorResponseDtt;
    };
  };
};

export const useCreateOrderForGroupBooking = () => {
  return useMutationTransformer<createOrderForGroupBooking, createOrderForGroupBookingDtt>({
    currentMutation: createOrderForGroupBookingUsingEmailLinkMutation,
    dttMutation: createOrderForGroupBookingUsingEmailLinkDttMutation,
    onTransform: data => {
      const { basicInformation, property } = data.createOrderForGroupBookingUsingEmailLink;
      return {
        sales: {
          groupSales: {
            createGroupBookingOrder: {
              basicInformation: {
                externalIdInfo: [
                  {
                    id: basicInformation.opportunityID,
                  },
                ],
              },
              property: {
                basicInformation: property.basicInformation,
                contactInformation: {
                  address: property.address,
                },
              },
            },
          },
        },
      };
    },
  });
};
